import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import amplitude from "amplitude-js";

const firebaseConfig = {
  apiKey: "AIzaSyCO3y8gkeJsS54yqGP-6gKVG74eFrIifKE",
  authDomain: "the-original-iq-tester.firebaseapp.com",
  projectId: "the-original-iq-tester",
  storageBucket: "the-original-iq-tester.appspot.com",
  messagingSenderId: "222011185910",
  appId: "1:222011185910:web:6cb8ffa92c9848469fead7",
  measurementId: "G-9ES0J3SK0M",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

// initialize Amplitude
amplitude.getInstance().init("43ac04129d8ed26c4c5d4c520036425a");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// register service worker to make app a PWA
serviceWorkerRegistration.register();
